module.exports = __webpack_public_path__ + "static/media/profile.8fbea08c.png";